import { isObject } from 'utils/DataType/isObject'
import { isFunction } from 'utils/DataType/isFunction'
import { isString } from 'utils/DataType/isString'

const onReadyStateChangeEvent = (readyState, fn) => {
  if (document.readyState && document.readyState !== 'complete') {
    document.addEventListener('readystatechange', event => {
      if (event.target.readyState === readyState || event.target.readyState === 'complete') {
        fn()
      }
    })

    return true
  }

  fn()
  return true
}


export const onReadyStateChange = (event = {}) => {
  if (!isObject(event) || !isFunction(event.fn) || !isString(event.readyState)) {
    let error = new Error('!!! ERROR (events.initialize:schedule:readyState) Unable to schedule function.  Invalid data type provided for readyState or function.')
    console.log(error)
    MK.captureException(error)
    return
  }

  event.fnName = event.fnName || 'anonymous'

  console.log(`DEBUG (schedule:readyStateChange:${event.readyState}) Scheduling function (${event.fnName}) for execution on document.${event.readyState}.`)

  // Schedule function execution at desired readyState
  onReadyStateChangeEvent(event.readyState, event.fn)
}